import React, { Fragment } from "react";
import Navbar from "../components/Navbar";
import RedemedTable from "../components/InvestorsTable";

const UsersScreen: React.FunctionComponent = () => {
   return (
      <Fragment>
         <Navbar />
         <RedemedTable />
      </Fragment>
   );
};

export default UsersScreen;
